<template>
  <div id="app">
    <router-view />
    <!-- Global UI singletons — teleported to <body> -->
    <AppToastContainer />
    <AppConfirmDialog />
    <!-- Global loading singleton — full-screen app init / login transition -->
    <AppLoader />
  </div>
</template>

<script>
import './assets/styles/main.css';
import AppToastContainer from '@/components/ui/AppToastContainer.vue';
import AppConfirmDialog from '@/components/ui/AppConfirmDialog.vue';
import AppLoader from '@/components/ui/loading/AppLoader.vue';

export default {
  name: 'App',
  components: {
    AppToastContainer,
    AppConfirmDialog,
    AppLoader,
  },
};
</script>

<style>
/* Base styles are now in main.css */
</style>
